import { moneyShort } from "@/components/marketplace/format"
import { itemAt } from "@/lib/helpers/array"

export const QUINCENAS = 4

const PRICE_STEPS = [500, 1000, 2500]

interface PriceTier {
  label: string
  open: boolean
  min?: number
  max?: number
}

const LAST_STEP = itemAt(PRICE_STEPS, PRICE_STEPS.length - 1)

export const PRICE_TIERS: PriceTier[] = [
  ...PRICE_STEPS.map((ceiling, index) => {
    const from = index > 0 ? PRICE_STEPS[index - 1] : undefined
    return {
      // A bare "$500" beside "$500–$1,000" reads as an exact amount rather than a
      // ceiling, so the first band names its floor like every other one.
      label: `${moneyShort(from ?? 0)}–${moneyShort(ceiling)}`,
      open: false,
      min: from,
      max: ceiling,
    }
  }),
  { label: `${moneyShort(LAST_STEP)}+`, open: true, min: LAST_STEP },
]
